"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var responsive_1 = require("./responsive");
exports.Responsive = responsive_1.Responsive;
exports.RESPONSIVE_DIRECTIVE = [responsive_1.Responsive];
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src727013012/src/~/ng2-responsive/responsive/index.js
// module id = khA/
// module chunks = 6